import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HomeComponent } from "./home/home.component";
import { HeaderComponent } from "./header/header.component";
import { ImpressumComponent } from "./impressum/impressum.component";
import { ScrollingService } from "./services/scrolling.service";

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    ImpressumComponent,
  ],
  imports: [BrowserModule, AppRoutingModule],
  providers: [ScrollingService],
  bootstrap: [AppComponent],
})
export class AppModule {}
